import tabsConstants from './tabs.constants';

function tabsReducer(state = {}, action) {
  switch (action.type) {
    case tabsConstants.REGISTER_NEW_TABS_COMPONENT:
      state = {
        ...state,
        [`${action.component}`]: 0,
      };
      break;

    case tabsConstants.CHANGE_TAB:
      state = {
        ...state,
        [`${action.component}`]: action.active || 0,
      };
      break;

    default:
      state = { ...state };
  }

  return state;
}

export default tabsReducer;